import { useTranslation } from 'react-i18next';
import { Badge } from '@mantine/core';
import { IconClockHour4 } from '@tabler/icons-react';

interface UpdatedDateBadgeProps {
  /** Дата изменения прайса «dd.MM.yyyy»; нет значения — бейдж не рисуем. */
  readonly date?: string;
}

// «Свежесть» прайса — мягкая серая пилюля той же формы, что счётчик прайсов (variant="light"),
// но тише: серый = метаданные. Белый текст на сером читался бы как «отключено» — поэтому light
// (светлый фон + тёмно-серый текст), а не filled. Иконка часов делает смысл считываемым с одного
// взгляда. Единый компонент для списка / детали / формы — вид одинаков везде.
export default function UpdatedDateBadge({ date }: UpdatedDateBadgeProps) {
  const { t } = useTranslation();
  if (!date) {
    return null;
  }
  return (
    <Badge
      variant="light"
      color="gray"
      tt="none"
      fw={500}
      leftSection={<IconClockHour4 size={12} />}
      style={{ flexShrink: 0 }}
    >
      {t('app.buy.updatedAt', { date })}
    </Badge>
  );
}
